export const LinkifyOptions = {
  attributes: {
    title: 'External Link',
  },
  className: 'underline text-blue-200 hover:text-blue-400 visited:text-purple-100',
  defaultProtocol: 'https',
  events: null,
  target: '_blank',
  rel: 'noopener',
};
